import { useInspectionDetailStore } from '@stores';
import { formatCurrency, formatName } from '@utils/formatters';

const SalePriceCard = () => {
  const { inspectionDetailData } = useInspectionDetailStore();
  const rawSalePrice =
    inspectionDetailData?.extraFields?.saleDetails?.vehicleSalePrice ??
    inspectionDetailData?.documents?.SALE_DETAILS?.extraFields?.saleDetails
      ?.vehicleSalePrice;
  const parsedSalePrice = Number(rawSalePrice);
  const salePrice =
    rawSalePrice != null && Number.isFinite(parsedSalePrice)
      ? formatCurrency(parsedSalePrice, 2)
      : 'Not provided';

  return (
    <div className="flex flex-col gap-6 border-t p-6">
      <h4 className="text-base font-semibold text-grey-800">
        Provided by{' '}
        {formatName(
          inspectionDetailData.seller.firstName,
          inspectionDetailData.seller.lastName
        )}
      </h4>
      <div className="flex items-center justify-between border-b border-grey-200 py-3.5">
        <span className="text-sm text-grey-500">Sale Price</span>
        <span className="text-base font-medium text-grey-700">{salePrice}</span>
      </div>
    </div>
  );
};

export default SalePriceCard;
